import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch } from 'src/app/hooks';
import Modal from 'src/components/Modal';
import { linkInvoiceToReceipt } from 'src/features/InvoiceGridSlice';

import { DialogActionsBar } from '@progress/kendo-react-dialogs';

import Button from 'src/components/design-system/Button';
import useRedirect from 'src/hooks/useRedirect';

type ConfirmLinkModalProps = {
  id: string;
  visible: boolean;
  width: string;
  title: string;
  closeModal: any;
  height: string;
  invoiceId: string;
  closeParentModal: (modalName: string) => void;
  receiptId: string | null;
  invoiceNumber?: string;
  previouslyLinkedReceiptId?: string;
};
function ConfirmLinkModal({
  id,
  visible,
  title,
  closeModal,
  width,
  height,
  invoiceId,
  invoiceNumber,
  closeParentModal,
  receiptId,
  previouslyLinkedReceiptId,
}: ConfirmLinkModalProps) {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const onReplaceInvoiceLinkClick = () => {
    dispatch(linkInvoiceToReceipt({ receiptId, invoiceId }))
      .unwrap()
      .then((res) => {
        closeParentModal(`Link a document to Receipt ${receiptId}`);
        closeModal(true);
      });
  };
  const close = () => closeModal(true);
  const { getUrl, redirect } = useRedirect();
  const handleClick = useCallback(() => {
    redirect(
      getUrl('invoiceDetails')(
        previouslyLinkedReceiptId as string,
        searchParams.get('poid') as string
      )
    );
  }, [getUrl, previouslyLinkedReceiptId, redirect, searchParams]);
  return (
    <Modal visible={visible} title={title} closeModal={closeModal} width={width} height={height}>
      {receiptId === previouslyLinkedReceiptId && (
        <div>
          Invoice {invoiceNumber} is already linked to Receipt {receiptId}
        </div>
      )}
      {receiptId !== previouslyLinkedReceiptId && (
        <div>
          <div>
            Invoice {invoiceNumber} is already linked to Receipt
            <button className="cursor-pointer text-link underline" onClick={handleClick}>
              {previouslyLinkedReceiptId}
            </button>
          </div>
          <div>Click Replace to replace existing link.</div>
          <div>Click Cancel to keep existing link.</div>
        </div>
      )}

      <DialogActionsBar>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {receiptId !== previouslyLinkedReceiptId && (
            <Button color="info" onClick={onReplaceInvoiceLinkClick}>
              Replace
            </Button>
          )}
          <Button color="info" onClick={close}>
            Cancel
          </Button>
        </div>
      </DialogActionsBar>
    </Modal>
  );
}

export default ConfirmLinkModal;
